import $ from 'jquery';

const productAccordion = () => {
	const $accordion = $('[data-accordion]');
	if (!$accordion.length) return;

	$accordion.find('.product-accordion__item').each(function () {
		const $item = $(this);
		const $button = $item.find('.product-accordion__header');
		const $panel = $item.find('.product-accordion__panel');

		$button.on('click', () => {
			const isOpen = $item.hasClass('is-open');

			if (isOpen) {
				closeItem($item, $button, $panel);
			} else {
				$accordion.find('.product-accordion__item.is-open').each(function () {
					const $openItem = $(this);
					closeItem(
						$openItem,
						$openItem.find('.product-accordion__header'),
						$openItem.find('.product-accordion__panel')
					);
				});

				openItem($item, $button, $panel);
			}
		});
	});
};

const openItem = ($item, $button, $panel) => {
	$item.addClass('is-open');
	$button.attr('aria-expanded', 'true');

	// prepare before paint
	$panel.removeAttr('hidden').css({ height: 0, opacity: 0 });

	// force reflow
	$panel[0].offsetHeight;

	const height = $panel[0].scrollHeight;
	$panel.css({ height, opacity: 1 });

	$panel.one('transitionend', (e) => {
		if (e.target !== $panel[0]) return;
		$panel.css('height', '');
	});
};

const closeItem = ($item, $button, $panel) => {
	$button.attr('aria-expanded', 'false');

	const height = $panel.outerHeight();
	$panel.css({ height, opacity: 1 });

	// force reflow
	$panel[0].offsetHeight;

	$panel.css({ height: 0, opacity: 0 });

	$panel.one('transitionend', (e) => {
		if (e.target !== $panel[0]) return;

		$item.removeClass('is-open');
		$panel.attr('hidden', true);
		$panel.removeAttr('style');
	});
};

try {
	productAccordion();
} catch (e) {
	console.error(e);
}
